import { InfoTooltip } from './InfoTooltip'
import { Select } from './Select'

export interface OptionalSettingSelectProps {
  label: string
  tooltip: string
  /** undefined = not set at this level. */
  value: string | undefined
  /** value -> label for every real choice. */
  labels: Record<string, string>
  /** Label of the first, "not set" choice - what applies instead. */
  unsetLabel: string
  onChange: (value: string | undefined) => void
}

// '' stands for "not set" inside the Select; it is never written to config.
const UNSET = ''

// A labelled dropdown for an optional config setting: a first "not set"
// choice (falls back to the next level), then the real choices. PRD 39.
export function OptionalSettingSelect({
  label,
  tooltip,
  value,
  labels,
  unsetLabel,
  onChange,
}: OptionalSettingSelectProps) {
  const options = [
    { value: UNSET, label: unsetLabel },
    ...Object.entries(labels).map(([optionValue, optionLabel]) => ({
      value: optionValue,
      label: optionLabel,
    })),
  ]
  return (
    <div className="flex flex-col gap-1">
      <span className="flex items-center gap-1 text-meta font-medium text-text-secondary">
        {label}
        <InfoTooltip text={tooltip} />
      </span>
      <Select
        value={value ?? UNSET}
        onChange={(next) => onChange(next === UNSET ? undefined : next)}
        options={options}
      />
    </div>
  )
}
